<template>

	<el-upload :action="'#'" :http-request="onFileUpload" :accept="fileTypes == null ? '' : fileTypes.join(',')"

		:show-file-list="false" :disabled="disabled" :before-upload="beforeUpload" :multiple="true">

		<slot></slot>

	</el-upload>

</template>



<script>

import {

	PRESIGNED_FILE_TYPE,

	uploadViaPresigned,

	wrapPresignedUploadFullResponse

} from '@/utils/imagePresignedUpload.js';



export default {

	name: "fileUpload",

	data() {

		return {

			loading: null,

			uploadHeaders: {

				"accessToken": sessionStorage.getItem('accessToken')

			}

		}

	},

	props: {

		action: {

			type: String,

			required: false

		},

		fileTypes: {

			type: Array,

			default: null

		},

		maxSize: {

			type: Number,

			default: null

		},

		showLoading: {

			type: Boolean,

			default: false

		},

		isPermanent: {

			type: Boolean,

			default: false

		},

		disabled: {

			type: Boolean,

			default: false

		},

		withResponseMeta: {

			type: Boolean,

			default: false

		}

	},

	methods: {

		resolvePresignedFileType() {

			const action = this.action || '';

			if (action === '/image/upload' || action.endsWith('/image/upload')) {

				return PRESIGNED_FILE_TYPE.IMAGE;

			}

			if (action === '/file/upload' || action.endsWith('/file/upload')) {

				return PRESIGNED_FILE_TYPE.FILE;

			}

			if (action === '/video/upload' || action.endsWith('/video/upload')) {

				return PRESIGNED_FILE_TYPE.VIDEO;

			}

			return null;

		},

		emitUploadProgress(progressEvent, rawFile) {

			this.$emit("progress", progressEvent, rawFile);

			try {

				this.$eventBus && this.$eventBus.$emit('upload:progress', {

					progressEvent,

					file: rawFile,

					action: this.action

				});

			} catch (e) {

				console.warn('emit upload:progress failed', e);

			}

		},

		emitUploadSuccess(data, rawFile) {

			this.$emit("success", data, rawFile);

			try {

				this.$eventBus && this.$eventBus.$emit('upload:success', { data, file: rawFile, action: this.action });

			} catch (e) {

				console.warn('emit upload:success failed', e);

			}

		},

		emitUploadFail(error, rawFile) {

			const canceled = error && (error.code === 'ERR_CANCELED' || error.name === 'CanceledError');

			try {

				this.$eventBus && this.$eventBus.$emit('upload:fail', { error, file: rawFile, action: this.action, canceled });

			} catch (err) {

				console.warn('emit upload:fail failed', err);

			}

		},

		uploadWithPresigned(rawFile, fileType) {

			uploadViaPresigned(rawFile, {

				fileType,

				onUploadProgress: (progressEvent) => this.emitUploadProgress(progressEvent, rawFile),

				signal: rawFile.uploadController.signal

			}).then((payload) => {

				const data = this.withResponseMeta ? wrapPresignedUploadFullResponse(payload) : payload;

				this.emitUploadSuccess(data, rawFile);

			}).catch((e) => {

				this.emitUploadFail(e, rawFile);

			}).finally(() => {

				this.loading && this.loading.close();

			});

		},

		onFileUpload(file) {

			const rawFile = file.file;

			rawFile.uploadController = new AbortController();

			// 展示加载条

			if (this.showLoading) {

				this.loading = this.$loading({

					lock: true,

					text: '正在上传...',

					spinner: 'el-icon-loading',

					background: 'rgba(0, 0, 0, 0.7)'

				});

			}

			const presignedFileType = this.resolvePresignedFileType();

			if (presignedFileType) {

				this.uploadWithPresigned(rawFile, presignedFileType);

				return;

			}

			let formData = new FormData()

			formData.append('file', rawFile)

			this.$http({

				url: this.action + '?isPermanent=' + this.isPermanent,

				data: formData,

				method: 'post',

				returnFullResponse: this.withResponseMeta,

				headers: {

					'Content-Type': 'multipart/form-data'

				},

				onUploadProgress: (progressEvent) => this.emitUploadProgress(progressEvent, rawFile),

				signal: rawFile.uploadController.signal

			}).then((data) => {

				this.emitUploadSuccess(data, rawFile);

			}).catch((e) => {

				this.emitUploadFail(e, rawFile);

			}).finally(() => {

				this.loading && this.loading.close();

			})

		},

		beforeUpload(file) {

			// 校验文件类型

			if (this.fileTypes && this.fileTypes.length > 0) {

				let fileType = file.type;

				let t = this.fileTypes.find((t) => t.toLowerCase() === fileType);

				if (t === undefined) {

					this.$message.error(`文件格式错误，请上传以下格式的文件：${this.fileTypes.join("、")}`);

					return false;

				}

			}

			// 校验大小

			if (this.maxSize && file.size > this.maxSize) {

				this.$message.error(`文件大小不能超过 ${this.fileSizeStr}!`);

				return false;

			}

			this.$emit("before", file);

			return true;

		}

	},

	computed: {

		fileSizeStr() {

			if (this.maxSize > 1024 * 1024) {

				return Math.round(this.maxSize / 1024 / 1024) + "M";

			}

			if (this.maxSize > 1024) {

				return Math.round(this.maxSize / 1024) + "KB";

			}

			return this.maxSize + "B";

		}

	}

}

</script>



<style></style>


